import { HttpHeaders } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { HttpService } from 'src/app/core/services/http.service';

@Component({
  selector: 'app-create-location',
  templateUrl: './create-location.component.html',
  styleUrls: ['./create-location.component.css']
})
export class CreateLocationComponent implements OnInit {
  @ViewChild('fileInput') fileInput!: ElementRef;
  form!: FormGroup;
  enterpriseId!: string;
  timezones: any[] = [];
  uploading = false;

  constructor(
    private httpService: HttpService,
    private authService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.enterpriseId = this.route.snapshot.paramMap.get('enterprise_id') || '';
    this.fetchTimezones();
    this.form = this.fb.group({
      locationName: ['', Validators.required],
      locationStreet: ['', Validators.required],
      locationCity: ['', Validators.required],
      locationState: ['', Validators.required],
      locationZip: ['', Validators.required],
      timezone: ['', Validators.required]
    });
  }

  uploadButtonClick() {
    this.fileInput.nativeElement.click();
  }

  async handleImageUpload(event: any) {
    const file = event.target.files[0];
    if (file) {
      const imageFormData = new FormData();
      imageFormData.append('file', file);
      this.uploading = true;
      try {
        const headers = new HttpHeaders({
          accept: 'text/plain',
          'X-Auth': this.authService.userObjectFromStorage?.api_key || ''
        });
        const response = await this.httpService
          .post(`ImageUploader/upload`, imageFormData, false, {
            headers,
            responseType: 'text' as 'json' // Specify responseType as 'text'
          })
          .toPromise();
        this.form.get('imageUrl')?.setValue(response as string);
      } catch (error) {
        console.error('Error uploading image:', error);
      } finally {
        this.uploading = false;
      }
    }
  }

  async createLocation() {
    if (this.form.invalid) return;

    const formData = this.form.value;

    const payload = {
      enterprise_Id: this.enterpriseId,
      name: formData.locationName,
      jsonStreetAddress: [
        {
          street: formData.locationStreet,
          city: formData.locationCity,
          state: formData.locationState,
          zipcode: formData.locationZip
        }
      ],
      timezone: formData.timezone
    };

    try {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'X-Auth': this.authService.userObjectFromStorage?.api_key || ''
      });

      await this.httpService
        .post(`Enterprise/${this.enterpriseId}/Location`, payload, true, {
          headers,
          responseType: 'text' as 'json'
        })
        .toPromise();
      this.router.navigate(['/overview']);
    } catch (err) {
      console.error('Error creating location:', err);
      alert('Error creating location');
    }
  }

  async fetchTimezones() {
    try {
      const timezonesResponse = await this.httpService
        .get<any[]>(`Configuration/Timezone/ListServedTimezones`)
        .toPromise();
      this.timezones = timezonesResponse || [];
    } catch (err) {
      console.error(err);
      alert('Error fetching timezones');
    }
  }
}
